var app = angular.module('leonardo');

var CurrencyRestService = function(BaseRestService) {
  return new BaseRestService('currencies');
};

app.factory('CurrencyRestService', ['BaseRestService', CurrencyRestService]);

